<template>
  <div class="loader--circular">
    <img src="@/assets/images/loader.gif" alt="Chargement en cours" />
  </div>
</template>

<script>
export default {};
</script>
